import React, { useState } from 'react';
import './Previous.css';

// Import des icônes
import stellIcon from '../../../../assets/icons/stell.png';
import cont1Icon from '../../../../assets/icons/cont1.png';
import cont2Icon from '../../../../assets/icons/cont2.png';
import cont3Icon from '../../../../assets/icons/cont3.png';
import cont4Icon from '../../../../assets/icons/cont4.png';
import pillIcon from '../../../../assets/icons/Icon-pill.svg';

// Import des données factices
import {
  previousVisitsData,
  previousTreatmentsData,
  getLatestVisit
} from '../../../fakedata/previousData';

const Previous = ({ visitData, treatmentsData, allVisitsData }) => {
  const [activeTab, setActiveTab] = useState('visit'); // 'visit' ou 'treatments'
  const [showAllVisits, setShowAllVisits] = useState(false); // État pour afficher toutes les visites

  // Utiliser les données passées en props ou les données par défaut
  const latestVisit = visitData || getLatestVisit();
  const treatments = treatmentsData || previousTreatmentsData;
  const allVisits = allVisitsData || previousVisitsData;

  // Déterminer quelles visites afficher
  const visitsToDisplay = showAllVisits ? allVisits : [latestVisit];

  // Handler pour le bouton "See all"
  const handleSeeAllClick = () => {
    setShowAllVisits(!showAllVisits);
  };

  // Map des icônes pour les métriques
  const iconMap = {
    cont1: cont1Icon,
    cont2: cont2Icon,
    cont3: cont3Icon,
    cont4: cont4Icon
  };

  return (
    <div className="previous-container">
      {/* Header avec onglets */}
      <div className="previous-header">
        <div
          className={`tab-item ${activeTab === 'visit' ? 'active' : ''}`}
          onClick={() => setActiveTab('visit')}
          style={{ cursor: 'pointer' }}
        >
          <span className="tab-text">Previous Visit Information</span>
          <div className={activeTab === 'visit' ? 'tab-underline' : 'tab-underline-gray'}></div>
        </div>
        <div
          className={`tab-item ${activeTab === 'treatments' ? 'active' : ''}`}
          onClick={() => setActiveTab('treatments')}
          style={{ cursor: 'pointer' }}
        >
          <span className="tab-text">Previous Treatments</span>
          <div className={activeTab === 'treatments' ? 'tab-underline' : 'tab-underline-gray'}></div>
        </div>
      </div>

      {/* Contenu conditionnel selon l'onglet actif */}
      {activeTab === 'visit' ? (
        <>
          {/* Section Latest Consultation Details */}
          <div className="consultation-header">
            <span className="consultation-title">
              {showAllVisits ? 'All Consultation Details' : 'Latest Consultation Details'}
            </span>
            <div
              className="see-all"
              onClick={handleSeeAllClick}
              style={{ cursor: 'pointer' }}
            >
              <span className="see-all-text">
                {showAllVisits ? 'Show less' : 'See all'}
              </span>
              <img
                src={stellIcon}
                alt="Arrow"
                className="stell-icon"
                style={{
                  transform: showAllVisits ? 'rotate(180deg)' : 'rotate(0deg)',
                  transition: 'transform 0.3s ease'
                }}
              />
            </div>
          </div>

          {/* Affichage dynamique de toutes les visites */}
          {visitsToDisplay.map((visit, index) => (
            <div key={visit.id} className="visit-item">
              {/* Container Date de visite */}
              <div className="date-container">
                <div className="date-line"></div>
                <div className="date-content">
                  <div className="date-text">
                    {visit.date.day}<br/>
                    {visit.date.month}<br/>
                    {visit.date.year}
                  </div>
                  <div className="date-separator"></div>
                  <div className="visit-info">
                    <div className="visit-section">
                      <div className="visit-label">Reason for Last Visit</div>
                      <div className="visit-description">{visit.reasonForVisit}</div>
                    </div>
                      <div className="date-separator"></div>
                    <div className="visit-section">
                      <div className="visit-label">Visit Conclusion</div>
                      <div className="visit-description">{visit.conclusion}</div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Métriques de santé */}
              <div className="metrics-container">
                {visit.metrics.map((metric) => (
                  <div key={metric.id} className="metric-item">
                    <div className="metric-icon-circle">
                      <img
                        src={iconMap[metric.icon]}
                        alt={metric.label}
                        className="metric-icon"
                      />
                    </div>
                    <div className="metric-label">{metric.label}</div>
                    <div className="metric-value-container">
                      <div className="metric-value">{metric.value}</div>
                      <div className="metric-unit">{metric.unit}</div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Séparateur entre les visites (sauf pour la dernière) */}
              {showAllVisits && index < visitsToDisplay.length - 1 && (
                <div className="visit-separator"></div>
              )}
            </div>
          ))}
        </>
      ) : (
        <>
          {/* Section Previous Treatments */}
          <div className="treatments-table-container">
            <div className="treatments-table-header">
              <div className="treatments-header-cell">Medicine</div>
              <div className="treatments-header-cell">Dose</div>
              <div className="treatments-header-cell">Start day</div>
              <div className="treatments-header-cell">Duration</div>
              <div className="treatments-header-cell">Status</div>
            </div>

            {treatments.map((treatment) => (
              <div key={treatment.id} className="treatments-table-row">
                <div className="treatments-cell treatments-medicine">
                  <div className="medicine-icon-wrapper">
                    <img src={pillIcon} alt="" className="pill-icon" />
                  </div>
                  <div className="medicine-info">
                    <div className="medicine-name">{treatment.medicine}</div>
                    <div className="medicine-dosage">{treatment.dosage}</div>
                  </div>
                </div>
                <div className="treatments-cell treatments-dose">
                  <div className="dose-text">{treatment.dose}</div>
                  <div className="dose-frequency">{treatment.frequency}</div>
                </div>
                <div className="treatments-cell treatments-start">
                  {treatment.startDay}
                </div>
                <div className="treatments-cell treatments-duration">
                  {treatment.duration}
                </div>
                <div className="treatments-cell treatments-status">
                  <span className={`status-badge status-${treatment.statusType}`}>
                    {treatment.status}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default Previous;